
const simple_vertex = `#version 300 es
    in vec4 a_position;
    void main() {
        gl_Position = a_position;
    }`;